import { DBVariable, EditableVariable } from "../types"

const editableVariableFromDBVariable = (
   dbVariable: DBVariable,
): EditableVariable => {
   return {
      key: dbVariable.key,
      humanReadableName: dbVariable.humanReadableName,
      type: dbVariable.type,
      version: dbVariable.version,
      defaultValue: dbVariable.defaultValue,
      constraints: dbVariable.constraints,
      config: dbVariable.config,
      projectId: dbVariable.projectId,
      constraintsVersion: dbVariable.constraintsVersion,
   } as EditableVariable
}

export { editableVariableFromDBVariable }
